const en = {
  // Legacy key aliases (used by old t() calls in components)
  add: 'Add', edit: 'Edit', save: 'Save', cancel: 'Cancel', delete: 'Delete',
  search: 'Search', export: 'Export', download: 'Download', signIn: 'Sign In',
  chassis: 'Chassis', make: 'Make', model: 'Model', year: 'Year', color: 'Color',
  mileage: 'Mileage', displacement: 'Displacement', transmission: 'Transmission',
  port: 'Port', status: 'Status', price: 'Price', cost: 'Cost', fobPrice: 'FOB Price',
  condition: 'Condition', quantity: 'Quantity', category: 'Category', fitment: 'Fitment',
  cutType: 'Cut Type', sku: 'SKU', name: 'Name', email: 'Email', password: 'Password',
  phone: 'Phone', company: 'Company', country: 'Country', scan: 'Scan QR',
  priceQuotes: 'Price Quotes', selectionOrders: 'Selection Orders', pricing: 'Pricing',
  vehicles: 'Vehicles', engines: 'Engines', parts: 'Parts', containers: 'Containers',
  customers: 'Customers', requests: 'Requests', employees: 'Staff', settings: 'Settings',
  dashboard: 'Dashboard', inventory: 'Inventory', myStock: 'My Stock',
  invoices: 'Invoices', payments: 'Payments', noData: 'No data available',
  loading: 'Loading...', totalUnits: 'Total Units', printQR: 'Print QR',
  whatsAppInquiry: 'WhatsApp Inquiry', viewDetails: 'View Details',
  staffPortal: 'Staff Portal', customerPortal: 'Customer Portal',
  invalidCredentials: 'Invalid credentials',

  // Dashboard - additional
  dash_good_morning: 'Good morning',
  dash_good_afternoon: 'Good afternoon',
  dash_good_evening: 'Good evening',
  dash_financial_overview: 'financial overview',
  dash_units_in_account: 'units in your account',
  dash_my_shipments: 'My Shipments',
  dash_on_the_way: 'On the Way',
  dash_arrived: 'Arrived',
  dash_no_shipments: 'No active shipments',
  dash_recommended: 'Recommended For You',
  dash_available_units: 'Available Units',
  dash_no_available: 'No available units right now.',
  dash_total_fob: 'Total FOB Value',
  dash_late_night: 'Late Night',
  dash_hello: 'Hello',
  dash_subtitle: "Here's a snapshot of your fleet, parts, and inbound shipments — updated in real time.",
  dash_local_time: 'LOCAL TIME',
  dash_status: 'STATUS',
  dash_all_systems_live: 'All systems live',
  dash_view_recommendations: 'View recommendations',
  dash_my_stock: 'MY STOCK',
  dash_in_transit: 'IN TRANSIT',
  dash_units: 'units',
  dash_containers: 'containers',
  dash_browse_more: 'Browse more',
  dash_track_shipments: 'Track shipments',
  dash_browse_inventory_start: 'Browse our inventory to start',
  dash_no_active_shipments: 'No active shipments',
  dash_next_eta: 'Next ETA in',
  dash_days: 'days',
  dash_etas_confirming: 'ETAs being confirmed',
  dash_this_week: 'THIS WEEK',
  dash_arriving_soon: 'ARRIVING SOON',
  dash_logistics: 'LOGISTICS',
  dash_active_shipments: 'Active shipments',
  dash_view_all: 'View all',
  dash_shipment_empty: 'Your next shipment will appear here when units are loaded into a container',
  dash_composition: 'COMPOSITION',
  dash_stock_breakdown: 'Stock breakdown',
  dash_no_units_yet: 'No units yet',
  dash_browse_to_build: 'Start browsing inventory to build your stock',
  dash_for_you: 'FOR YOU',
  dash_picked_based: 'Picked based on your stock',
  dash_browse_all: 'Browse all',
  dash_picking_units: "We're picking units for you. Check back soon, or browse our full inventory",
  dash_view_details: 'View details',
  dash_just_arrived: 'JUST ARRIVED',
  dash_similar: 'SIMILAR TO YOURS',
  dash_today: 'Today',
  dash_tomorrow: 'Tomorrow',
  dash_total_cost: 'Total Cost Basis',
  dash_gross_margin: 'Gross Margin',
  dash_awaiting_pricing: 'Awaiting Pricing',
  dash_vehicle_fob: 'Vehicle FOB Total',
  dash_engine_fob: 'Engine FOB Total',
  dash_parts_fob: 'Parts FOB Total',
  dash_total_freight: 'Total Freight Cost',
  dash_fob_by_make: 'FOB Value by Vehicle Make',
  dash_no_priced_vehicles: 'No priced vehicles yet',
  dash_top_units: 'Top 5 Units by FOB',
  dash_no_priced_units: 'No priced units yet',
  dash_margin: 'margin',
  dash_container_breakdown: 'Container Financial Breakdown',
  dash_no_containers: 'No containers yet',
  dash_container: 'Container',
  dash_route: 'Route',
  dash_units: 'Units',
  dash_freight_cost: 'Freight Cost',
  dash_fob_value: 'FOB Value',
  dash_net_after_freight: 'Net After Freight',
  dash_receivables: 'Receivables',
  dash_total: 'Total',
  dash_current: 'Current',
  dash_overdue: 'Overdue',
  dash_oldest: 'Oldest',
  dash_days: 'days',
  dash_this_month: 'This Month',
  dash_invoiced: 'Invoiced',
  dash_received: 'Received',
  dash_avg_margin: 'Avg Margin',
  dash_quotes_sent: 'Quotes Sent',
  dash_pending_actions: 'Pending Actions',
  dash_receipts_verify: 'payment receipts need verification',
  dash_units_pricing: 'units need pricing',
  dash_invoices_overdue: 'invoices overdue',
  dash_customer_balances: 'Customer Balances',
  dash_customer_overview: 'Customer Overview',
  dash_top_customers: 'Top Customers (by revenue)',
  dash_attention: 'Attention',
  dash_no_customer_data: 'No customer data yet.',
  dash_no_customers: 'No customers yet',
  dash_no_activity: 'No recent activity',
  dash_price_quotes: 'Price Quotes',
  dash_pending: 'Pending',
  dash_in_progress: 'In Progress',
  dash_quoted_week: 'Quoted This Week',
  recentActivity: 'Recent Activity',
  inventoryValue: 'Inventory Value',
  inTransit: 'In Transit',
  pendingRequests: 'Pending Requests',

  // Navigation
  nav_dashboard: 'Dashboard',
  nav_inventory: 'Inventory',
  nav_my_stock: 'My Stock',
  nav_my_selection: 'My Selection',
  nav_containers: 'Containers',
  nav_requests: 'Requests',
  nav_invoices: 'Invoices',
  nav_payments: 'Payments',
  nav_customers: 'Customers',
  nav_employees: 'Staff',
  nav_audit_log: 'Audit Log',
  nav_settings: 'Settings',
  nav_cms: 'Website CMS',
  nav_inquiries: 'Inquiries',
  nav_trade_apps: 'Buyer Applications',
  nav_website_cars: 'Cars on Website',
  nav_bulk_parts: 'Bulk Parts Upload',
  nav_pricing: 'Pricing',
  nav_price_quotes: 'Price Quotes',
  nav_selection_orders: 'Selection Orders',
  nav_tasks: 'Tasks',
  nav_scan: 'QR Scanner',
  nav_cut_plans: 'Cut Plans',
  nav_yard_map: 'Yard Map',
  nav_yard_pricing: 'Yard Pricing',
  nav_walkin_customers: 'Walk-in Customers',
  nav_yard_history: 'Sales History',
  nav_market_prices: 'Market Prices',
  nav_sign_out: 'Sign Out',

  // Common actions
  btn_save: 'Save',
  btn_cancel: 'Cancel',
  btn_delete: 'Delete',
  btn_edit: 'Edit',
  btn_add: 'Add',
  btn_submit: 'Submit',
  btn_approve: 'Approve',
  btn_reject: 'Reject',
  btn_download: 'Download',
  btn_upload: 'Upload',
  btn_search: 'Search',
  btn_export: 'Export',
  btn_clear: 'Clear',
  btn_confirm: 'Confirm',
  btn_close: 'Close',
  btn_view: 'View',
  btn_remove: 'Remove',
  btn_back: 'Back',
  btn_next: 'Next',
  btn_save_changes: 'Save Changes',
  btn_sign_in: 'Sign In',
  btn_contact_us: 'Contact Us',

  // Login
  login_title: 'BIG STAR',
  login_subtitle: 'Vehicle Export Management',
  login_staff_portal: 'Staff Portal',
  login_customer_portal: 'Customer Portal',
  login_username: 'Username',
  login_email: 'Email',
  login_password: 'Password',
  login_remember: 'Remember me',
  login_invalid: 'Invalid credentials',
  login_frozen: 'Your account has been frozen. Please contact an administrator.',
  login_blocked: 'Your account has been suspended. Please contact support.',
  login_timeout: 'Your session timed out due to inactivity. Please sign in again.',

  // Inventory
  inv_add_to_stock: 'Add to My Stock',
  inv_in_stock: 'In My Stock',
  inv_reserved: 'Reserved',
  inv_sold: 'Sold',
  inv_available: 'Available',
  inv_search_placeholder: 'Search vehicles, parts, engines...',
  inv_no_results: 'No items found',
  inv_vehicle: 'Vehicle',
  inv_engine: 'Engine',
  inv_spare_part: 'Spare Part',
  inv_vehicles: 'Vehicles',
  inv_engines: 'Engines',
  inv_parts: 'Parts',
  inv_all: 'All',
  inv_add_vehicle: 'Add Vehicle',
  inv_add_engine: 'Add Engine',
  inv_add_part: 'Add Spare Part',
  inv_total_units: 'Total Units',
  inv_no_data: 'No data available',
  inv_per_page: 'per page',
  inv_page: 'Page',
  inv_of: 'of',

  // Vehicle details
  detail_make: 'Make',
  detail_model: 'Model',
  detail_year: 'Year',
  detail_chassis: 'Chassis',
  detail_color: 'Color',
  detail_mileage: 'Mileage',
  detail_grade: 'Grade',
  detail_score: 'Score',
  detail_engine_code: 'Engine Code',
  detail_transmission: 'Transmission',
  detail_fuel: 'Fuel Type',
  detail_steering: 'Steering',
  detail_drive: 'Drive System',
  detail_condition: 'Condition',
  detail_status: 'Status',
  detail_price: 'Price',
  detail_fob: 'FOB Price',
  detail_chassis_number: 'Chassis Number',
  detail_displacement: 'Displacement',
  detail_port: 'Port',
  detail_city: 'City',
  detail_seats: 'Seats',
  detail_category: 'Category',
  detail_fitment: 'Fitment',
  detail_quantity: 'Quantity',
  detail_sku: 'SKU',
  detail_cut_type: 'Cut Type',
  detail_photos: 'Photos',
  detail_notes: 'Notes',

  // Statuses
  status_available: 'Available',
  status_assigned: 'Assigned',
  status_sold: 'Sold',
  status_shipped: 'Shipped',
  status_in_transit: 'In Transit',
  status_at_port: 'At Port',
  status_customs: 'Customs',
  status_delivered: 'Delivered',
  status_japan_yard: 'Japan Yard',
  status_loading: 'Loading',
  status_loaded: 'Loaded',
  status_pending: 'Pending',
  status_approved: 'Approved',
  status_rejected: 'Rejected',
  status_planning: 'Planning',
  status_booked: 'Booked',
  status_sealed: 'Sealed',
  status_closed: 'Closed',

  // My Stock
  stock_title: 'My Stock',
  stock_available_section: 'Available Units',
  stock_in_review: 'In Review',
  stock_approved_section: 'Approved',
  stock_empty: 'Your stock is empty. Browse inventory to add units.',
  stock_remove_confirm: 'Remove this unit from your stock?',
  stock_remove_note: 'It will become available to other buyers.',
  stock_request_quote: 'Request Quote',
  stock_quote_requested: 'Quote Requested',
  stock_price_pending: 'Price: Pending',
  stock_my_orders: 'My Orders',

  // Selection
  sel_units_selected: '{count} units selected',
  sel_total: 'Total',
  sel_continue: 'Continue',
  sel_submit: 'Submit Final Selection',
  sel_review_title: 'Review Your Selection',
  sel_review_subtitle: 'Review your units before submitting for approval',
  sel_notes_placeholder: 'Add any notes or special requests...',
  sel_submit_confirm: 'You are about to submit {count} units for approval. Once submitted, these units will be reserved. Continue?',
  sel_submitted: 'Your selection has been submitted for review!',
  sel_orders_title: 'My Selection Orders',
  sel_no_orders: 'No orders yet.',

  // Containers
  cont_title: 'Containers',
  cont_no_containers: 'No containers yet. Your units will appear here once loaded for shipping.',
  cont_destination: 'Destination',
  cont_eta: 'ETA',
  cont_units_inside: 'Units in this container',
  cont_seal: 'Seal Number',
  cont_timeline: 'Timeline',
  cont_download_bl: 'Download BL',
  cont_payment_required: 'Complete payment to receive BL',
  cont_bl_processing: 'BL surrender in progress',
  cont_arrived: 'Container Arrived',
  cont_mark_received: 'Mark as Received',
  cont_new: 'New Container',
  cont_start_loading: 'Start Loading',
  cont_mark_loaded: 'Mark Loaded',
  cont_complete_loading: 'Complete Loading',
  cont_add_update: 'Add Update',

  // Invoices
  invoice_title: 'Invoices',
  invoice_action_required: 'Action Required',
  invoice_completed: 'Completed',
  invoice_payment_history: 'Payment History',
  invoice_total_invoiced: 'Total Invoiced',
  invoice_total_paid: 'Paid',
  invoice_outstanding: 'Outstanding',
  invoice_overdue: 'Overdue',
  invoice_upload_receipt: 'Upload Receipt',
  invoice_download_pdf: 'Download PDF',
  invoice_payment_due: 'Payment due',
  invoice_days_overdue: '{days} days overdue',
  invoice_fully_paid: 'Fully Paid',
  invoice_proforma: 'Proforma',
  invoice_view_details: 'View Details',

  // Condition reporting
  cond_good: 'Good',
  cond_minor_damage: 'Minor Damage',
  cond_major_damage: 'Major Damage',
  cond_missing_parts: 'Missing Parts',

  // Dashboard
  dash_welcome: 'Welcome, {name}',
  dash_total_units: 'Total Units',
  dash_inventory_value: 'Inventory Value',
  dash_in_transit: 'In Transit',
  dash_pending_requests: 'Pending Requests',

  // Settings
  settings_title: 'Settings',
  settings_profile: 'My Profile',
  settings_name: 'Name',
  settings_phone: 'Phone',
  settings_new_password: 'New Password',
  settings_keep_current: 'leave blank to keep current',

  // Notifications
  notif_title: 'Notifications',
  notif_mark_read: 'Mark as read',
  notif_no_new: 'No new notifications',

  // Payments page
  pay_title: 'Payments',
  pay_verified: 'VERIFIED PAYMENTS',
  pay_no_verified: 'No verified payments yet.',
  pay_add: 'Add Payment',
  pay_outgoing: 'OUTGOING PAYMENTS',
  pay_no_outgoing: 'No outgoing payments recorded.',
  pay_export_csv: 'Export CSV',
  pay_verify: 'Verify',
  pay_reject: 'Reject',
  pay_view_receipt: 'View Receipt',
  pay_view_invoice: 'View Invoice',
  pay_amount: 'Amount',
  pay_method: 'Method',
  pay_date: 'Date',
  pay_reference: 'Reference',

  // Invoices page - additional
  invoice_no_invoices: 'No Invoices',
  invoice_empty_msg: 'Invoices will appear here when generated.',
  invoice_all_customers: 'All Customers',
  invoice_send: 'Send to Customer',
  invoice_save_draft: 'Save Draft',
  invoice_line_items: 'Line Items',
  invoice_subtotal: 'Subtotal',
  invoice_fees: 'Fees',
  invoice_grand_total: 'Grand Total',
  invoice_milestones: 'Payment Milestones',

  // Selection Orders
  selorder_title: 'Selection Orders',
  selorder_no_orders: 'No Selection Orders',
  selorder_empty_msg: 'Customer selection orders will appear here when submitted.',
  selorder_approve: 'Approve',
  selorder_reject: 'Reject',
  selorder_units: 'Units',
  selorder_customer: 'Customer',
  selorder_status: 'Status',
  selorder_submitted: 'Submitted',

  // Containers - additional
  cont_new_container: 'New Container',
  cont_freight: 'FREIGHT',
  cont_search_placeholder: 'search container, vessel, seal',
  cont_in_transit: 'In transit',
  cont_loading: 'loading',
  cont_origin: 'Origin',
  cont_vessel: 'Vessel',
  cont_voyage: 'Voyage',
  cont_size: 'Size',
  cont_status: 'Status',
  cont_units_count: 'Units',
  cont_planned_departure: 'Planned Departure',
  cont_actual_departure: 'Actual Departure',

  // Requests - additional
  req_title: 'Requests',
  req_new: 'New Request',
  req_reply: 'Reply',
  req_view: 'View',
  req_pending: 'Pending',
  req_processing: 'Processing',
  req_sourced: 'Sourced',
  req_cancelled: 'Cancelled',
  req_budget: 'Budget',
  req_type_vehicle: 'Vehicle',
  req_type_engine: 'Engine',
  req_type_part: 'Spare Part',

  // Common UI
  ui_all_customers: 'All Customers',
  ui_export_csv: 'Export CSV',
  ui_no_data: 'No data available',
  ui_show: 'Show',
  ui_per_page: 'per page',
  ui_page: 'Page',
  ui_of: 'of',
  ui_edit: 'Edit',
  ui_delete: 'Delete',
  ui_download: 'Download',
  ui_new: 'New',
  ui_reply: 'Reply',

  // Detail - additional labels
  detail_location: 'Location',
  detail_manufacturer: 'Manufacturer',
  detail_assign_customer: 'Assign to Customer',
  detail_assigned_to: 'Assigned to',
  detail_not_assigned: 'Not assigned',
  detail_unassign: 'Unassign',
  detail_no_notes: 'No notes',
  detail_request_parts: 'Request Parts from This Vehicle',
  detail_arrived_yard: 'Arrived at Your Yard',
  detail_return_stock: 'Cancel / Return to Stock',
  detail_download_photos: 'Download Photos',

  // Inventory - filters
  inv_all_items: 'All Items',
  inv_all_status: 'All Status',
  inv_all_makes: 'All Makes',
  inv_all_years: 'All Years',
  inv_all_transmissions: 'All Transmissions',
  inv_all_conditions: 'All Conditions',
  inv_all_categories: 'All Categories',
  inv_all_countries: 'All Countries',
  inv_item: 'Item',
  inv_details: 'Details',
  inv_days: 'Days',
  inv_show: 'Show',
  inv_request_parts: 'Request Parts',
  inv_how_want_vehicle: 'How do you want this vehicle?',
  inv_full_vehicle: 'Full Vehicle',
  inv_full_vehicle_desc: 'Complete vehicle as-is',
  inv_custom: 'Custom',
  inv_custom_desc: 'Describe your request',
  inv_newest: 'Newest First',
  inv_oldest: 'Oldest First',
  inv_price_high: 'Price: High to Low',
  inv_price_low: 'Price: Low to High',
  inv_days_desc: 'Days in Stock',

  // Misc
  misc_all_customers: 'All Customers',
  misc_viewing: 'Viewing',
  misc_clear_filter: 'Clear Filter',
  misc_no_data: 'No data available',
  misc_loading: 'Loading...',
  misc_country: 'Country',
  misc_currency: 'Currency',
  misc_cost_summary: 'Cost Summary',
  misc_total_fob: 'Total FOB',
  misc_yes: 'Yes',
  misc_no: 'No',
};

export default en;
